module.exports = __webpack_public_path__ + "static/img/NSW-29.0ede911.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-29.jpg
// module id = W7Ru
// module chunks = 0